document.documentElement.classList.add('ks-js');

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function revealElements(root = document) {
  const elements = [...root.querySelectorAll('[data-ks-reveal]:not(.is-visible)')];

  if (reducedMotion.matches || !('IntersectionObserver' in window)) {
    elements.forEach((element) => element.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  elements.forEach((element) => observer.observe(element));
}

function initializeBackToTop(root = document) {
  const button = root.querySelector('[data-ks-back-to-top]') || document.querySelector('[data-ks-back-to-top]');
  if (!button || button.dataset.ksReady === 'true') return;

  button.dataset.ksReady = 'true';
  const updateVisibility = () => {
    button.hidden = window.scrollY < 720;
  };

  button.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
  });
  window.addEventListener('scroll', updateVisibility, { passive: true });
  updateVisibility();
}

function initializeCountdowns(root = document) {
  const timers = [...root.querySelectorAll('[data-ks-countdown]')];

  timers.forEach((timer) => {
    if (timer.dataset.ksReady === 'true') return;

    const targetTime = Date.parse(timer.dataset.endDate || '');
    if (Number.isNaN(targetTime)) {
      timer.dataset.ksReady = 'invalid';
      return;
    }

    timer.dataset.ksReady = 'true';
    const fields = {
      days: timer.querySelector('[data-ks-countdown-days]'),
      hours: timer.querySelector('[data-ks-countdown-hours]'),
      minutes: timer.querySelector('[data-ks-countdown-minutes]'),
      seconds: timer.querySelector('[data-ks-countdown-seconds]'),
    };
    const expiredMessage = timer.querySelector('[data-ks-countdown-expired]');
    const pad = (value) => String(value).padStart(2, '0');

    const render = () => {
      const distance = targetTime - Date.now();

      if (distance <= 0) {
        Object.values(fields).forEach((field) => {
          if (field) field.textContent = '00';
        });
        timer.classList.add('is-expired');
        if (expiredMessage) {
          expiredMessage.textContent = timer.dataset.expiredText || '';
          expiredMessage.hidden = !expiredMessage.textContent;
        }
        window.clearInterval(timer.ksCountdownInterval);
        return;
      }

      const days = Math.floor(distance / 86400000);
      const hours = Math.floor((distance % 86400000) / 3600000);
      const minutes = Math.floor((distance % 3600000) / 60000);
      const seconds = Math.floor((distance % 60000) / 1000);
      if (fields.days) fields.days.textContent = pad(days);
      if (fields.hours) fields.hours.textContent = pad(hours);
      if (fields.minutes) fields.minutes.textContent = pad(minutes);
      if (fields.seconds) fields.seconds.textContent = pad(seconds);
    };

    render();
    timer.ksCountdownInterval = window.setInterval(render, 1000);
  });
}

function initializeKwitnacy(root = document) {
  revealElements(root);
  initializeBackToTop(root);
  initializeCountdowns(root);
}

initializeKwitnacy();
document.addEventListener('shopify:section:load', (event) => initializeKwitnacy(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-ks-countdown]').forEach((timer) => {
    window.clearInterval(timer.ksCountdownInterval);
  });
});
